module.exports = __webpack_public_path__ + "static/LAUNCH-45a8f59c2ae2ac18e9fc9addd9561f37.png";